// extracted by mini-css-extract-plugin
module.exports = {"chip":"chip-1OTGhsIQnop3Y45pOfOfO7","icon":"icon-2OPgPxFbMAtkzN-78DUSYS"};